import React, { PureComponent } from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, LineChart, Line, Brush, LabelList, ReferenceLine, Label } from 'recharts';

import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Stack } from '@mui/material';

const red = '#dd2c00';
let data = [
  {
    ISO: 12
  },
  {
    ISO: 12
  },{
    ISO: 10
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 12
  },{
    ISO: 13
  },{
    ISO: 11
  },
  {
    ISO: 12
  },
  {
    ISO: 1
  },
  
  {
    ISO: 12
  },{
    ISO: 13
  },{
    ISO: 12
  },{
    ISO: 11
  },{
    ISO: 12
  },{
    ISO: 12
  },{
    ISO: 10
  }, {
    ISO: 17
  },{
    ISO: 10
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 12
  },{
    ISO: 13
  },{
    ISO: 11
  },{
    ISO: 10
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 12
  },{
    ISO: 13
  },{
    ISO: 11
  }, {
    ISO: 17
  },{
    ISO: 12
  },{
    ISO: 12
  },{
    ISO: 12
  }, {
    ISO: 12
  },
  {
    ISO: 12
  },{
    ISO: 10
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 12
  },{
    ISO: 13
  },{
    ISO: 11
  },
  {
    ISO: 12
  },
  {
    ISO: 1
  },
  
  {
    ISO: 12
  },{
    ISO: 13
  },{
    ISO: 12
  },{
    ISO: 11
  },{
    ISO: 12
  },{
    ISO: 12
  },{
    ISO: 5
  }, {
    ISO: 17
  },{
    ISO: 25
  },{
    ISO: 25
  },{
    ISO: 25
  },{
    ISO: 25
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 12
  },{
    ISO: 13
  },{
    ISO: 11
  },{
    ISO: 10
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 12
  },{
    ISO: 13
  },{
    ISO: 11
  }, {
    ISO: 15
  },{
    ISO: 12
  },{
    ISO: 12
  },{
    ISO: 12
  }, {
    ISO: 12
  },
  {
    ISO: 12
  },{
    ISO: 10
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 12
  },{
    ISO: 13
  },{
    ISO: 11
  },
  {
    ISO: 12
  },
  {
    ISO: 5
  },
  
  {
    ISO: 12
  },{
    ISO: 13
  },{
    ISO: 12
  },{
    ISO: 11
  },{
    ISO: 12
  },{
    ISO: 12
  },{
    ISO: 1
  }, {
    ISO: 17
  },{
    ISO: 10
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 12
  },{
    ISO: 13
  },{
    ISO: 11
  },{
    ISO: 10
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 12
  },{
    ISO: 13
  },{
    ISO: 11
  }, {
    ISO: 14
  },{
    ISO: 12
  },{
    ISO: 12
  },{
    ISO: 12
  }, {
    ISO: 12
  },
  {
    ISO: 12
  },{
    ISO: 10
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 12
  },{
    ISO: 13
  },{
    ISO: 11
  },
  {
    ISO: 12
  },
  {
    ISO: 5
  },
  
  {
    ISO: 12
  },{
    ISO: 13
  },{
    ISO: 12
  },{
    ISO: 11
  },{
    ISO: 12
  },{
    ISO: 12
  },{
    ISO: 5
  }, {
    ISO: 22
  },{
    ISO: 10
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 12
  },{
    ISO: 13
  },{
    ISO: 11
  },{
    ISO: 10
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 12
  },{
    ISO: 13
  },{
    ISO: 11
  }, {
    ISO: 17
  },{
    ISO: 12
  },{
    ISO: 12
  },{
    ISO: 12
  }, {
    ISO: 12
  },
  {
    ISO: 12
  },{
    ISO: 10
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 12
  },{
    ISO: 13
  },{
    ISO: 11
  },
  {
    ISO: 12
  },
  {
    ISO: 5
  },
  
  {
    ISO: 12
  },{
    ISO: 13
  },{
    ISO: 12
  },{
    ISO: 11
  },{
    ISO: 12
  },{
    ISO: 12
  },{
    ISO: 5
  }, {
    ISO: 17
  },{
    ISO: 25
  },{
    ISO: 25
  },{
    ISO: 25
  },{
    ISO: 25
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 12
  },{
    ISO: 13
  },{
    ISO: 11
  },{
    ISO: 10
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 12
  },{
    ISO: 13
  },{
    ISO: 11
  }, {
    ISO: 15
  },{
    ISO: 12
  },{
    ISO: 12
  },{
    ISO: 12
  }, {
    ISO: 12
  },
  {
    ISO: 12
  },{
    ISO: 10
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 12
  },{
    ISO: 13
  },{
    ISO: 11
  },
  {
    ISO: 12
  },
  {
    ISO: 5
  },
  
  {
    ISO: 12
  },{
    ISO: 13
  },{
    ISO: 12
  },{
    ISO: 11
  },{
    ISO: 12
  },{
    ISO: 12
  },{
    ISO: 1
  }, {
    ISO: 17
  },{
    ISO: 10
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 12
  },{
    ISO: 13
  },{
    ISO: 11
  },{
    ISO: 10
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 12
  },{
    ISO: 13
  },{
    ISO: 11
  }, {
    ISO: 14
  },{
    ISO: 12
  },{
    ISO: 12
  },{
    ISO: 12
  }, {
    ISO: 12
  },
  {
    ISO: 12
  },{
    ISO: 10
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 12
  },{
    ISO: 13
  },{
    ISO: 11
  },
  {
    ISO: 12
  },
  {
    ISO: 5
  },
  
  {
    ISO: 12
  },{
    ISO: 13
  },{
    ISO: 12
  },{
    ISO: 11
  },{
    ISO: 12
  },{
    ISO: 12
  },{
    ISO: 5
  }, {
    ISO: 22
  },{
    ISO: 10
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 12
  },{
    ISO: 13
  },{
    ISO: 11
  },{
    ISO: 10
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 12
  },{
    ISO: 13
  },{
    ISO: 11
  }, {
    ISO: 17
  },{
    ISO: 12
  },{
    ISO: 12
  },{
    ISO: 12
  }, {
    ISO: 12
  },
  {
    ISO: 12
  },{
    ISO: 10
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 12
  },{
    ISO: 13
  },{
    ISO: 11
  },
  {
    ISO: 12
  },
  {
    ISO: 5
  },
  {
    ISO: 12
  },{
    ISO: 13
  },{
    ISO: 12
  },{
    ISO: 11
  },{
    ISO: 12
  },{
    ISO: 12
  },{
    ISO: 5
  }, {
    ISO: 17
  },{
    ISO: 10
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 12
  },{
    ISO: 13
  },{
    ISO: 11
  },{
    ISO: 10
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 12
  },{
    ISO: 13
  },{
    ISO: 11
  }, {
    ISO: 17
  },{
    ISO: 12
  },{
    ISO: 12
  },{
    ISO: 12
  }, {
    ISO: 12
  },
  {
    ISO: 12
  },{
    ISO: 10
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 12
  },{
    ISO: 13
  },{
    ISO: 11
  },
  {
    ISO: 12
  },
  {
    ISO: 1
  },
  
  {
    ISO: 12
  },{
    ISO: 13
  },{
    ISO: 12
  },{
    ISO: 11
  },{
    ISO: 12
  },{
    ISO: 12
  },{
    ISO: 10
  }, {
    ISO: 17
  },{
    ISO: 10
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 12
  },{
    ISO: 13
  },{
    ISO: 11
  },{
    ISO: 10
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 12
  },{
    ISO: 13
  },{
    ISO: 11
  }, {
    ISO: 17
  },{
    ISO: 12
  },{
    ISO: 12
  },{
    ISO: 12
  },
];
let data2 = [
 {
    ISO: 10
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 12
  },{
    ISO: 1
  },{
    ISO: 11
  }, {
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 11
  }, {
    ISO: 11
  },
  {
    ISO: 11
  },{
    ISO: 10
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 11
  },
  {
    ISO: 11
  },
  {
    ISO: 12
  },
  {
    ISO: 10
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 12
  },{
    ISO: 1
  },{
    ISO: 11
  }, {
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 11
  }, {
    ISO: 11
  },
  {
    ISO: 11
  },{
    ISO: 10
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 11
  },
  {
    ISO: 11
  },
  {
    ISO: 12
  },
  {
    ISO: 10
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 12
  },{
    ISO: 1
  },{
    ISO: 11
  }, {
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 11
  }, {
    ISO: 11
  },
  {
    ISO: 11
  },{
    ISO: 10
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 11
  },
  {
    ISO: 11
  },
  {
    ISO: 12
  },
  {
    ISO: 10
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 12
  },{
    ISO: 1
  },{
    ISO: 11
  }, {
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 11
  }, {
    ISO: 11
  },
  {
    ISO: 11
  },{
    ISO: 10
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 11
  },
  {
    ISO: 11
  },
  {
    ISO: 12
  },
  {
    ISO: 10
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 12
  },{
    ISO: 1
  },{
    ISO: 11
  }, {
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 11
  }, {
    ISO: 11
  },
  {
    ISO: 10
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 12
  },{
    ISO: 1
  },{
    ISO: 11
  }, {
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 11
  }, {
    ISO: 11
  },
  {
    ISO: 11
  },{
    ISO: 10
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 11
  },
  {
    ISO: 11
  },
  {
    ISO: 12
  },
  {
    ISO: 10
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 12
  },{
    ISO: 1
  },{
    ISO: 11
  }, {
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 11
  }, {
    ISO: 11
  },
  {
    ISO: 11
  },{
    ISO: 10
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 11
  },
  {
    ISO: 11
  },
  {
    ISO: 12
  },
  
  {
    ISO: 11
  },{
    ISO: 10
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 11
  },
  {
    ISO: 11
  },
  {
    ISO: 12
  },
  
  {
    ISO: 12
  },{
    ISO: 11
  },{
    ISO: 12
  },{
    ISO: 11
  },{
    ISO: 12
  },{
    ISO: 12
  },{
    ISO: 12
  }, {
    ISO: 12
  },{
    ISO: 10
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 12
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 10
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 12
  },{
    ISO: 11
  },{
    ISO: 11
  }, {
    ISO: 14
  },{
    ISO: 12
  }, {
    ISO: 12
  },
  {
    ISO: 12
  },{
    ISO: 10
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 12
  },{
    ISO: 11
  },{
    ISO: 11
  },
  {
    ISO: 12
  },
  {
    ISO: 10
  },
  
  {
    ISO: 12
  },{
    ISO: 11
  },{
    ISO: 12
  },{
    ISO: 11
  },{
    ISO: 12
  },{
    ISO: 12
  },{
    ISO: 9
  }, {
    ISO: 17
  },{
    ISO: 23
  },{
    ISO: 10
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 12
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 10
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 12
  },{
    ISO: 11
  },{
    ISO: 11
  }, {
    ISO: 11
  },{
    ISO: 12
  },{
    ISO: 12
  },{
    ISO: 12
  }, {
    ISO: 12
  },
  {
    ISO: 12
  },{
    ISO: 10
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 12
  },{
    ISO: 11
  },{
    ISO: 23
  },{
    ISO: 23
  },{
    ISO: 11
  },
  {
    ISO: 12
  },
  {
    ISO: 1
  },
  
  {
    ISO: 12
  },{
    ISO: 11
  },{
    ISO: 12
  },{
    ISO: 11
  },{
    ISO: 12
  },{
    ISO: 12
  },{
    ISO: 10
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 12
  },{
    ISO: 11
  },{
    ISO: 11
  },
  {
    ISO: 12
  },
  {
    ISO: 1
  },
  
  {
    ISO: 12
  },{
    ISO: 11
  },{
    ISO: 12
  },{
    ISO: 11
  },{
    ISO: 12
  },{
    ISO: 12
  },{
    ISO: 1
  }, {
    ISO: 10
  },{
    ISO: 10
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 12
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 10
  },{
    ISO: 5
  }, {
    ISO: 17
  },{
    ISO: 10
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 12
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 12
  },{
    ISO: 12
  }, {
    ISO: 12
  },
  {
    ISO: 12
  },{
    ISO: 10
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 12
  },{
    ISO: 11
  },{
    ISO: 11
  },
  {
    ISO: 12
  },
  {
    ISO: 5
  },
  
  {
    ISO: 12
  },{
    ISO: 11
  },{
    ISO: 12
  },{
    ISO: 11
  },{
    ISO: 12
  },{
    ISO: 12
  },{
    ISO: 23
  },{
    ISO: 10
  }, {
    ISO: 12
  },{
    ISO: 10
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 12
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 10
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 12
  },{
    ISO: 11
  },{
    ISO: 11
  }, {
    ISO: 17
  },{
    ISO: 12
  },{
    ISO: 12
  },{
    ISO: 12
  }, {
    ISO: 12
  },
  {
    ISO: 12
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 12
  },{
    ISO: 11
  },{
    ISO: 11
  }, {
    ISO: 17
  },{
    ISO: 12
  },{
    ISO: 12
  },{
    ISO: 12
  }, {
    ISO: 12
  },
  {
    ISO: 12
  },{
    ISO: 10
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 12
  },{
    ISO: 11
  },{
    ISO: 11
  },
  {
    ISO: 12
  },
  {
    ISO: 5
  },
  
  {
    ISO: 12
  },{
    ISO: 11
  },{
    ISO: 12
  },{
    ISO: 11
  },{
    ISO: 12
  },{
    ISO: 12
  },{
    ISO: 1
  }, {
    ISO: 12
  },{
    ISO: 10
  },{
    ISO: 23
  },{
    ISO: 11
  },{
    ISO: 12
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 10
  },{
    ISO: 11
  },{
    ISO: 11
  },{
    ISO: 12
  },{
    ISO: 13
  },{
    ISO: 11
  }, {
    ISO: 12
  },{
    ISO: 12
  },{
    ISO: 12
  },{
    ISO: 12
  },
];
let data3 = [
  {
    ISO: 2
  },
  {
    ISO: 23
  },{
    ISO: 21
  },{
    ISO: 23
  },{
    ISO: 25
  },{
    ISO: 23
  },{
    ISO: 18
  },{
    ISO: 23
  },{
    ISO: 23
  },{
    ISO: 23
  },{
    ISO: 18
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 23
  },
  {
    ISO: 23
  },{
    ISO: 21
  },{
    ISO: 23
  },{
    ISO: 23
  },{
    ISO: 23
  },{
    ISO: 23
  },{
    ISO: 23
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 23
  },
  {
    ISO: 23
  },{
    ISO: 21
  },{
    ISO: 23
  },{
    ISO: 23
  },{
    ISO: 23
  },{
    ISO: 21
  },{
    ISO: 23
  },{
    ISO: 23
  },{
    ISO: 23
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 23
  },
  {
    ISO: 23
  },{
    ISO: 21
  },{
    ISO: 23
  },{
    ISO: 23
  },{
    ISO: 23
  },{
    ISO: 21
  },{
    ISO: 23
  },{
    ISO: 23
  },{
    ISO: 23
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 16
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 20
  },{
    ISO: 20
  },{
    ISO: 20
  },{
    ISO: 20
  },{
    ISO: 20
  },{
    ISO: 20
  },{
    ISO: 20
  },{
    ISO: 20
  },{
    ISO: 20
  },{
    ISO: 16
  },{
    ISO: 20
  },{
    ISO: 20
  },{
    ISO: 20
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 23
  },
  {
    ISO: 23
  },{
    ISO: 21
  },{
    ISO: 23
  },{
    ISO: 13
  },{
    ISO: 23
  },{
    ISO: 23
  },{
    ISO: 23
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 23
  },
  {
    ISO: 23
  },{
    ISO: 21
  },{
    ISO: 23
  },{
    ISO: 23
  },{
    ISO: 23
  },{
    ISO: 23
  },{
    ISO: 23
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 23
  },
  {
    ISO: 23
  },{
    ISO: 5
  },{
    ISO: 6
  },{
    ISO: 8
  },{
    ISO: 9
  },{
    ISO: 5
  },{
    ISO: 6
  },{
    ISO: 8
  },{
    ISO: 9
  },{
    ISO: 21
  },{
    ISO: 23
  },{
    ISO: 23
  },{
    ISO: 23
  },{
    ISO: 23
  },{
    ISO: 23
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 5
  },{
    ISO: 6
  },{
    ISO: 8
  },{
    ISO: 9
  },{
    ISO: 5
  },{
    ISO: 6
  },{
    ISO: 8
  },{
    ISO: 9
  },{
    ISO: 21
  },{
    ISO: 23
  },
  {
    ISO: 23
  },{
    ISO: 21
  },{
    ISO: 23
  },{
    ISO: 23
  },{
    ISO: 23
  },{
    ISO: 12
  },{
    ISO: 23
  },{
    ISO: 23
  },{
    ISO: 23
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 23
  },
  {
    ISO: 23
  },{
    ISO: 21
  },{
    ISO: 23
  },{
    ISO: 23
  },{
    ISO: 23
  },{
    ISO: 21
  },{
    ISO: 23
  },{
    ISO: 23
  },{
    ISO: 23
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 21
  },{
    ISO: 20
  },{
    ISO: 20
  },{
    ISO: 20
  },{
    ISO: 20
  },{
    ISO: 20
  },{
    ISO: 5
  },{
    ISO: 6
  },{
    ISO: 8
  },{
    ISO: 9
  },{
    ISO: 20
  },{
    ISO: 20
  },{
    ISO: 20
  },{
    ISO: 20
  },{
    ISO: 20
  },{
    ISO: 20
  },{
    ISO: 20
  },{
    ISO: 20
  },{
    ISO: 23
  },
  {
    ISO: 23
  },{
    ISO: 21
  },{
    ISO: 23
  },{
    ISO: 23
  },{
    ISO: 23
  },{
    ISO: 21
  },{
    ISO: 23
  },{
    ISO: 23
  },{
    ISO: 23
  },{
    ISO: 20
  },{
    ISO: 20
  },{
    ISO: 20
  },{
    ISO: 20
  },{
    ISO: 20
  },{
    ISO: 20
  },{
    ISO: 20
  },{
    ISO: 16
  },
  {
    ISO: 16
  },{
    ISO: 16
  },{
    ISO: 16
  },{
    ISO: 16
  },{
    ISO: 16
  },{
    ISO: 16
  },{
    ISO: 16
  },{
    ISO: 16
  },{
    ISO: 16
  },{
    ISO: 16
  },{
    ISO: 16
  },{
    ISO: 16
  },{
    ISO: 16
  },{
    ISO: 16
  },{
    ISO: 16
  },{
    ISO: 16
  },{
    ISO: 16
  },{
    ISO: 16
  },{
    ISO: 24
    
  },
  {
    ISO: 16
  },
  {
    ISO: 16
  },
  {
    ISO: 20
  },{
    ISO: 19
  },{
    ISO: 19
  },{
    ISO: 19
  },{
    ISO: 19
  },{
    ISO: 19
  },{
    ISO: 19
  },{
    ISO: 20
  },{
    ISO: 20
  },{
    ISO: 20
  },{
    ISO: 20
  },{
    ISO: 20
  },{
    ISO: 20
  },{
    ISO: 20
  },{
    ISO: 20
  },{
    ISO: 20
  },{
    ISO: 13
  },{
    ISO: 14
  },{
    ISO: 15
  },{
    ISO: 16
  },{
    ISO: 19
  },{
    ISO: 20
  },{
    ISO: 20
  },{
    ISO: 20
  },{
    ISO: 20
  },{
    ISO: 20
  },{
    ISO: 20
  },{
    ISO: 19
  },{
    ISO: 20
  },{
    ISO: 20
  },{
    ISO: 20
  },{
    ISO: 20
  },{
    ISO: 20
  },{
    ISO: 20
  },{
    ISO: 19
  },{
    ISO: 20
  },{
    ISO: 20
  },{
    ISO: 20
  },{
    ISO: 20
  },{
    ISO: 20
  },{
    ISO: 18
  },
  {
    ISO: 18
  },{
    ISO: 18
  },{
    ISO: 19
  },{
    ISO: 17
  },{
    ISO: 13
  },{
    ISO: 19
  },{
    ISO: 19
  },{
    ISO: 19
  },{
    ISO: 17
  },{
    ISO: 18
  },
  {
    ISO: 18
  },{
    ISO: 18
  },{
    ISO: 19
  },{
    ISO: 19
  },{
    ISO: 17
  },{
    ISO: 19
  },{
    ISO: 19
  },{
    ISO: 18
  },
  {
    ISO: 18
  },{
    ISO: 17
  },{
    ISO: 10
  },{
    ISO: 19
  },{
    ISO: 19
  },{
    ISO: 19
  },{
    ISO: 19
  },{
    ISO: 18
  },
  {
    ISO: 18
  },{
    ISO: 18
  },{
    ISO: 19
  },{
    ISO: 19
  },{
    ISO: 19
  },{
    ISO: 19
  },{
    ISO: 17
  },
  {
    ISO: 18
  },{
    ISO: 18
  },{
    ISO: 19
  },{
    ISO: 14
  },{
    ISO: 19
  },{
    ISO: 19
  },


];

let hour = 10;

// const DateNow = () => {
//   hour++;
//   if(hour === 25){
//     hour = 1;
//   }
//     return hour+ ":00";

// }

export default function Iso4406LineChart ({name, alarm}) {
   
    SetTime(10);
    data.forEach(element => {
      element.t = AddTime()
    });
    SetTime(10);
    data2.forEach(element => {
      element.t = AddTime()
    })
    SetTime(10);
    data3.forEach(element => {
      element.t = AddTime()
    })
    return test()
 
}

let time = 10;
function AddTime () {
  time++;
  if(time ===25){
    time = 1;
  }
  return time+":00";
}
function SetTime(setTime){
  time = setTime;
}


function Iso4406LineChart2 ({name ="ISO", alarm = false, dataSheet = data, brush = false, maxValue=18}) {
  
    dataSheet = dataSheet.slice(0,300);  
    let avg = GetAvg(dataSheet);
    let height = brush? "250px" : "220px"; 
    return (
    <div style={{ width: "33%", height: height }}>
    <h4 style={{color:"white",  height:"30px"}} >
        {name}
        {alarm === true? <ErrorOutlineIcon  fontSize="large" style={{ color: red, marginLeft:"10px" }}/>  : null}
    </h4>
      <ResponsiveContainer >
      <AreaChart
         syncId="anyId"
          width={500}
          height={400}
          data={dataSheet}
          margin={{
            top: 10,
            right: 30,
            left: 0,
            bottom: 0,
          }}
        >
            <defs>
                        <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="0%" stopColor="#1b5e20" stopOpacity={0.7} />
                            <stop offset="60%" stopColor="#1b5e20" stopOpacity={0.2} />
                        </linearGradient>
                     

                        <filter id="shadow" height="200%">
                            <feDropShadow dx="0" dy="10" stdDeviation="10" />
                        </filter>

                    </defs>

          <CartesianGrid strokeDasharray="3 3" strokeOpacity={0.7} />
          <XAxis fontSize={18}  stroke ="lightGrey"  minTickGap={40} strokeOpacity={1}  dataKey={"t"} />
          <YAxis domain={[0, 'dataMax + 2']} fontSize={18}  stroke ="lightGrey" type="number" strokeOpacity={1} />
          <Tooltip />
          <Area type="monotone"  dataKey="ISO" 
          stroke="#66bb6a" strokeWidth={1}
          
          strokeOpacity={0.9} 
          fill="url(#colorUv)"
          // fill="url(#colorISO)"
          />
          {brush? 
          <Brush height={30} fill="#263238" /> : null}
     
          <ReferenceLine y={maxValue}  strokeWidth="1.5" stroke="red" opacity="1"  strokeDasharray="3 3"/>
      
        </AreaChart>
      </ResponsiveContainer>
      <h6 style={{color:"lightGrey"}}  >
        Average: {avg}
    </h6>
    </div>
    );
  
}
function GetAvg(data) {
  let avgA = data;
  let avg = 0;
  data.forEach(element => {
    avg +=element.ISO;
  });
  avg = avg/avgA.length

  return <>{avg.toFixed(2)}</>
}


  function test (){
      
    return  <div style={{ width: '100%', height:'100%' }}>
    <Stack direction={"row"} justifyContent="space-evenly"
 alignItems="flex-start"
  spacing={0} >

 
   <Iso4406LineChart2 name={"ISO 4"}  dataSheet={data} maxValue={23}/>
   <Iso4406LineChart2 name={"ISO 6"}  dataSheet={data2} brush={true} maxValue={21}/>     
   <Iso4406LineChart2 name={"ISO 14"} dataSheet={data3} alarm={true} maxValue={19} />

    </Stack>

  </div>
}

